"use client";
import React, { useState } from "react";
import MainLogo from "./MainLogo";
import TopBtns from "./TopBtns";
import Link from "next/link";
import CountryID from "./CountryID";
import "react-datepicker/dist/react-datepicker.css";
import {
  ChnagePassword,
  ResetPassword,
  SignIn,
  SignOut,
  SignUp,
} from "../services/authorization";
import LoadingPage from "./LoadingPage";
import { GetCookie } from "../cookies/CookiesSetUp";
import { Affiliate } from "../cookies/CookiesType";
import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import { OpenCashier } from "../services/cashier";
import DatePickerDropdown from "./DatePickerDropdown";
import { GetActiveCoupon } from "../services/coupon";
import { useEffect, useRef, useCallback } from "react";
import MainMenu from "./MainMenu";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import MessageCenter from "./MessageCenter";
import { Suspense } from "react";
import CouponCashier from "./CouponCashier";
import EmailVerificationBanner from "./EmailVerificationBanner";
import WipTransferModal from "./wipTransferModal/WipTransferModal";
import CashbackButton from "./cashback/CashbackButton";
import styles from "./wipTransferModal/WipTransferModal.module.scss";
import {
  identifyCustomer,
  resetCustomerIo,
  trackCustomerIoEvent,
} from "../lib/customerio";
import { fireBttrEventSafe } from "../lib/bttr";

const LogoColor = "#ffffff";

const disposableDomains = new Set();

async function loadBlacklistParts() {
  const parts = 5; // number of parts
  for (let i = 1; i <= parts; i++) {
    const res = await fetch(`/data/disposableDomainsPart${i}.json`);
    const list = await res.json();

    list.forEach((domain) => disposableDomains.add(domain));
  }
}

function isDisposableEmail(email) {
  const domain = email.split("@")[1]?.toLowerCase();
  return disposableDomains.has(domain);
}

export default function BarTop() {
  // --------------------------[TOGGLE BOX FORM USER DETAILS/ COUPONS]┐
  const [isUserDetailsVisible, setUserDetailsVisible] = useState(true);

  // --------------------------[TOGGLE BOX FORM USER DETAILS/ COUPONS]┘

  // ---------------------------------------------[GENDER]┐
  const [selectedGender, setSelectedGender] = useState("");
  const handleGenderChange = (event) => {
    setSelectedGender(event.target.value);
  };
  // ---------------------------------------------[GENDER]┘

  // Test Tarik
  const [birthDate, setBirthDate] = useState("");
  const [countryId, setCountryId] = useState("");

  const [formLoginData, setFormLoginData] = useState({
    username: "",
    password: "",
  });
  const [formSignupData, setFormSignupData] = useState(null);
  const [errorLoginMessage, setErrorLoginMessage] = useState(null);
  const [errorRegisterMessage, setErrorRegisterMessage] = useState(null);
  const {
    user,
    setUser,
    pageLoader,
    setPageLoader,
    isClosed,
    setIsClosed,
    isMobile,
    setLink,
    setOpenModal,
    setIsCouponOpen,
    setActiveCoupon,
    setIsCouponActivated,
    countries,
    setPaymentResponse,
    setErrorMessagePayment,
    games,
    setFreeSpinGame,
    refreshUserProfile,
  } = useContext(AppContext);
  const [errorResetMessage, setErrorResetMessage] = useState(null);

  const [openWip, setOpenWip] = useState(false);

  const fireBttrEvent = (eventType) => fireBttrEventSafe(eventType);

  // Step 4: Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormLoginData({
      ...formLoginData,
      [name]: value,
    });
  };

  const handleInputSignupChange = (e) => {
    const { name, value } = e.target;

    var reg = new RegExp(/^\d+$/);
    if (reg.test(value) === false && name === "phoneNumber" && value !== "") {
      e.target.value = "";
      return;
    }

    setFormSignupData({
      ...formSignupData,
      [name]: value,
    });
  };
  const handleDateChange = (date) => setBirthDate(date);
  const handleChangeCountryId = (event) => setCountryId(event.target.value);

  const [hideBtnsBarTop, setHideBtnsBarTop] = useState(false);

  const Click_Login = () => {
    setIsClosed(false);
    handleTabChange("login");
    setHideBtnsBarTop(true);
  };
  const Click_Signup = () => {
    setIsClosed(false);
    handleTabChange("signup");
    setHideBtnsBarTop(true);
  };

  const Click_ResetPassword = () => {
    setIsClosed(false);
    handleTabChange("reset-password");
    setHideBtnsBarTop(true);
  };

  const CloseMainLoginForm = () => {
    setIsClosed(true);
    setHideBtnsBarTop(false);
  };

  const openCashier = useCallback(
    async (cashierTab = "1", couponCode = null) => {
      setPageLoader(true);
      try {
        const baseUrl = await OpenCashier(cashierTab);
        if (!baseUrl || typeof baseUrl !== "string") {
          return false;
        }

        const nextUrl = couponCode
          ? `${baseUrl}${
              baseUrl.includes("?") ? "&" : "?"
            }coupon=${encodeURIComponent(couponCode)}`
          : baseUrl;

        setLink(nextUrl);
        if (isMobile && typeof Tawk_API !== "undefined") {
          Tawk_API.hideWidget();
        }
        document.body.style.overflow = "hidden";
        setOpenModal(true);
        setIsClosed(true);
        return true;
      } catch {
        return false;
      } finally {
        setPageLoader(false);
      }
    },
    [isMobile, setIsClosed, setLink, setOpenModal, setPageLoader],
  );

  //open cashier in new tab ->

  // const openCashier = (cashierTab = "1", couponCode = null) => {
  //   setPageLoader(true);

  //   OpenCashier(cashierTab)
  //     .then((response) => {
  //       if (couponCode) response += `&coupon=${couponCode}`;
  //       window.open(response, '_blank');
  //     })
  //     .catch(() => { })
  //     .finally(() => setPageLoader(false));
  // };

  //ShowHidePass
  const [passwordVisible, setPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const passwordContainer = {
    position: "relative",
    display: "flex",
    alignItems: "center",
    paddingBottom: "20px",
  };

  const passwordToggleIconStyle = {
    position: "absolute",
    right: "10px",
    top: "35%", // Postavlja ikonicu na sredinu input polja
    transform: "translateY(-50%)",
    cursor: "pointer",
  };

  const passwordToggleIconStyleReset = {
    position: "absolute",
    right: "10px",
    top: "35%", // Postavlja ikonicu na sredinu input polja
    transform: "translateY(-50%)",
    cursor: "pointer",
  };

  const passwordToggleIconStyleBlack = {
    position: "absolute",
    right: "10px",
    top: "35%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "white",
  };

  const passwordToggleIconStyleWhite = {
    position: "absolute",
    right: "10px",
    top: "35%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "white",
  };

  const [passwordIconStyle, setPasswordIconStyle] = useState(
    passwordToggleIconStyleBlack,
  );
  const passwordInputRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (passwordInputRef.current) {
        const backgroundColor = window.getComputedStyle(
          passwordInputRef.current,
        ).backgroundColor;
        if (backgroundColor === "rgb(0, 0, 0)") {
          setPasswordIconStyle(passwordToggleIconStyleWhite);
        } else {
          setPasswordIconStyle(passwordToggleIconStyleBlack);
        }
      }
    }, 0);
  }, [passwordVisible, formLoginData.password]);

  useEffect(() => {
    loadBlacklistParts();
  }, []);

  // TABS CONTROL LOGIN FORM
  const [activeTab, setActiveTab] = useState("login");
  const handleTabChange = (tab) => setActiveTab(tab);

  const [state, setState] = useState(null);
  const BtnSignup = (event) => {
    event.preventDefault();
    setErrorRegisterMessage(null);

    if (
      formSignupData?.email &&
      isDisposableEmail(formSignupData.email.trim())
    ) {
      setErrorRegisterMessage("Disposable email addresses are not allowed.");
      return;
    }

    const affiliateId = GetCookie(Affiliate);
    const trimmedEmail = formSignupData?.email?.trim();
    if (!trimmedEmail) {
      setErrorRegisterMessage("Email is required.");
      return;
    }

    const trimmedPassword = formSignupData?.password?.trim();

    const data = {
      firstName:
        formSignupData?.firstName?.trim()[0].toUpperCase() +
        formSignupData?.firstName?.trim()?.slice(1),
      lastName:
        formSignupData?.lastName?.trim()[0].toUpperCase() +
        formSignupData?.lastName?.trim()?.slice(1),
      userName: trimmedEmail, // login = email
      password: trimmedPassword,
      email: trimmedEmail,
      phoneNumber: formSignupData?.phoneNumber?.trim(),
      birthDate,
      countryId,
      ...(affiliateId != null && String(affiliateId).trim() !== ""
        ? { affiliateId }
        : {}),
      address: formSignupData?.address,
      zipCode: formSignupData?.zipCode,
      state,
      gender: selectedGender === "male",
    };

    const authData = {
      username: trimmedEmail,
      password: trimmedPassword,
      cf_token: "TarikToken",
    };

    setPageLoader(true);
    SignUp(data)
      .then(async (response) => {
        console.info("[BTT][signup] success confirmed");
        fireBttrEvent("conversion1");

        // Ensure HTTP auth session is created so refresh keeps user logged in.
        const loggedInUser = await SignIn(authData);

        try {
          if (typeof CDK !== "undefined" && trimmedPassword) {
            await CDK.logIn(
              authData.username,
              trimmedPassword,
              true,
              true,
              true,
            );
          }
        } catch (cdkError) {
          console.warn(
            "CDK login after signup failed:",
            cdkError?.message || cdkError,
          );
        }

        // finalize UI state
        setFormSignupData(null);
        setCountryId("");
        setBirthDate("");
        setSelectedGender("");
        // Hydrate full profile before CouponCashier evaluates email status.
        // identify uses that profile so deposit fields are not taken from signup.
        let profile = loggedInUser;
        if (typeof refreshUserProfile === "function") {
          profile =
            (await refreshUserProfile({ mergeWith: loggedInUser })) ||
            loggedInUser;
        } else {
          setUser(loggedInUser);
        }

        try {
          await identifyCustomer(profile);
          trackCustomerIoEvent("Signed Up", {
            user: profile?.email || loggedInUser?.email,
            brand: "goat",
          });
        } catch (cioErr) {
          console.warn("Customer.io tracking failed:", cioErr);
        }
        setIsClosed(true);
      })
      .catch((error) => {
        setErrorRegisterMessage(
          error?.message ||
            error?.response?.data?.message ||
            "Registration failed.",
        );
      })
      .finally(() => setPageLoader(false));
  };

  const BtnLogout = (username) => {
    if (!username) {
      return;
    }
    setPageLoader(true);
    setIsClosed(true);
    setHideBtnsBarTop(false);
    const data = {
      username: user.username,
    };
    SignOut(data)
      .then(async () => {
        setUser(null);
        await Tawk_API.logout();
        await CDK.logOut();
        await resetCustomerIo();
        setActiveCoupon(null);
        setIsCouponActivated(false);
        setPaymentResponse(null);
        setErrorMessagePayment(null);
      })
      .catch(() => {
        setUser(null);
      })
      .finally(() => setPageLoader(false));
  };

  const BtnLogin = async (event) => {
    event.preventDefault();
    setErrorLoginMessage(null);
    setIsChangePasswordSucced(false);
    setPageLoader(true);
    const data = {
      username: formLoginData.username.trim(),
      password: formLoginData.password.trim(),
      cf_token: "TarikToken",
    };
    try {
      const response = await SignIn(data);
      await CDK.logIn(
        formLoginData.username,
        formLoginData.password,
        true,
        true,
        true,
      );
      const game = await CDK.getFreeSpinCouponInfo();
      if (game?.FreeSpinInfo?.Gameid) {
        let findGame = games.find(
          (value) =>
            value?.gameId === game?.FreeSpinInfo?.Gameid &&
            value?.machineId === game?.FreeSpinInfo?.Machid,
        );
        if (findGame && game?.FreeSpinInfo?.SpinsRemaining > 0) {
          findGame = {
            ...findGame,
            remainingSpins: game?.FreeSpinInfo?.SpinsRemaining,
          };
          setFreeSpinGame(findGame);
          document.getElementById("idFreeSpin").style.display = "block";
        }
      }
      // Prefer authoritative profile (includes emailVerificationStatus and deposits).
      // Avoid setUser(loginResponse) alone — CouponCashier would treat missing
      // verification fields as unknown/unverified. Sign-in payload often has
      // totalDepositsCount 0, so identify only the GetUserInfo profile.
      let profile = null;
      if (typeof refreshUserProfile === "function") {
        profile = await refreshUserProfile({ mergeWith: response });
      } else {
        setUser(response);
        profile = response;
      }
      if (profile && profile !== response) {
        try {
          await identifyCustomer(profile);
        } catch (cioErr) {
          console.warn("Customer.io identify failed:", cioErr?.message || cioErr);
        }
      }
        try {

            if (typeof affiliateId === "undefined" ||affiliateId != 397) {
                fireBttrEvent("exclusion3");
            }

        } catch (error) {
            console.dir(error);
        }
      await GetActiveCoupon()
        .then((coupon) => {
          if (coupon !== 204) {
            setActiveCoupon(coupon[0]);
            setIsCouponActivated(coupon[0]?.bank_method_list ? false : true);
          }
        })
        .catch(() => {});

      setIsClosed(true);
      setHideBtnsBarTop(false); // dodato zbog problema se logovanjem tj ne prikazanim ui da je user ulogovan
    } catch (error) {
      setErrorLoginMessage(error.message || "Unknown error!");
    } finally {
      setPageLoader(false);
    }
  };

  //Reset password
  const [formResetData, setFormResetData] = useState(null);
  const [isRessetSucced, setIsResetSucced] = useState(false);
  const [isChangePasswordSucced, setIsChangePasswordSucced] = useState(false);
  const handleInputChangeUserName = (e) => {
    const { name, value } = e.target;
    setFormResetData({
      ...formResetData,
      [name]: value,
    });
  };

  const BtnResetPassword = (event) => {
    event.preventDefault();
    setErrorResetMessage(null);
    setPageLoader(true);
    if (isRessetSucced) {
      ChnagePassword(formResetData)
        .then((response) => {
          setFormResetData(null);
          setIsChangePasswordSucced(true);
          setActiveTab("login");
          setIsResetSucced(false);
        })
        .catch((error) => {
          setErrorResetMessage(
            error?.message ||
              error?.response?.data?.message ||
              "Unable to change password.",
          );
        })
        .finally(() => setPageLoader(false));
    } else {
      ResetPassword(formResetData)
        .then((response) => {
          setIsResetSucced(true);
        })
        .catch((error) => {
          setErrorResetMessage(
            error?.message ||
              error?.response?.data?.message ||
              "Unable to reset password.",
          );
        })
        .finally(() => setPageLoader(false));
    }
  };

  // CouponCashier must stay mounted during pageLoader so pending/in-flight
  // guards survive openCashier loader toggles.
  return (
    <>
      <Suspense fallback={null}>
        <CouponCashier
          openCashier={openCashier}
          Click_Login={Click_Login}
          Click_Signup={Click_Signup}
        />
      </Suspense>
      {pageLoader ? (
        <LoadingPage loader={pageLoader} />
      ) : (
    <div id="BarTop" className="NoSelect">
      <MainMenu />
      <MainLogo fill={LogoColor} />

      <button
        type="button"
        className={user ? styles.wipBtnLogged : styles.wipBtn}
        onClick={() => setOpenWip(true)}
        aria-haspopup="dialog"
        aria-controls="wip-transfer-modal"
      >
        VIP Transfer
      </button>
      <WipTransferModal
        open={openWip}
        onClose={() => setOpenWip(false)}
        managerEmail={
          process.env.NEXT_PUBLIC_MANAGER_EMAIL || "manager@yourcasino.com"
        }
      />

      {/* USER DETAILS */}
      {user && (
        <>
          <div id="ContUserIcons">
            {/* CASHBACK — same slot as BarTopNewSite.jsx (inside the
                absolutely-positioned icon cluster), NOT centered loose in
                the bar like before — that was the overlap bug. */}
            <CashbackButton />
            {/* MESSAGES BUTTON */}
            {user && <MessageCenter user={user} />}
            {/* USER IS LOGGED */}
            {/* BALANCE */}
            <div id="BoxTopBalance" onClick={() => openCashier("3")}>
              {user?.balance} {user?.currencyId}
            </div>
            {/* BALANCE */}
            <div id="BoxUserName" onClick={Click_Login}>
              {user?.username}
            </div>
            {/* USER IS LOGGED */}
          </div>
        </>
      )}

      <div id="ContCreNot">
        {/* SI NOT LOGGED */}
        {!user && (
          <>
            {/* LOGIN/SIGNUP */}

            <TopBtns
              onClick={Click_Login}
              // ClassBtn="BtnsTop GreyBlue"
              // ClassBtn={
              //   hideBtnsBarTop ? "BtnsTop Cyan Hide" : "BtnsTop GreyBlue"
              // }
              className="LoginBtn"
            >
              Login
            </TopBtns>
            <TopBtns
              onClick={Click_Signup}
              // ClassBtn="BtnsTop Cyan"
              // ClassBtn={hideBtnsBarTop ? "BtnsTop Cyan Hide" : "BtnsTop SignUp"}
              className="SignupBtn"
            >
              Sign up
            </TopBtns>
          </>
        )}
        {/* SI NOT LOGGED */}

        {/* BELL NOTIFICATIONS */}
        {/* <div id="BoxBell"><IconBell /></div> */}
      </div>
      {/* -----------------------------------------[MAIN LOGIN FORM]┐ */}
      <div id="ContLogRegForm" className={`${isClosed ? "Close" : ""}`}>
        <div id="BoxLogRegForm" className="NoSelect">
          <div id="NavBarRegForm">
            {!user && (
              <div id="ContNav_L_S">
                <div
                  id="BtnShow_Login"
                  className={`BtnNavLS ${
                    activeTab === "login" ? "Active" : ""
                  }`}
                  onClick={() => handleTabChange("login")}
                >
                  Login
                </div>
                <div
                  id="BtnShow_Signup"
                  className={`BtnNavLS ${
                    activeTab === "signup" ? "Active" : ""
                  }`}
                  onClick={() => handleTabChange("signup")}
                >
                  Sign up
                </div>
              </div>
            )}
            <div id="BtnClose_LR_Form" onClick={CloseMainLoginForm}></div>
          </div>

          {/* --------------------------------------[HIDE  IF USER IS LOGGED]┐ */}
          {!user && (
            <>
              {/* <!-- LOGIN BOX --> */}
              {activeTab === "login" && (
                <div id="LoginBox" className="ContPopupForms">
                  <form className="LoginForm" onSubmit={BtnLogin}>
                    <input
                      type="text"
                      name="username"
                      placeholder="Email"
                      value={formLoginData?.username}
                      onChange={handleInputChange}
                      onKeyDown={(e) =>
                        e.code === "Space" && e.preventDefault()
                      }
                      autoComplete="off"
                      required
                    />
                    <div
                      className="passwordContainer"
                      style={passwordContainer}
                    >
                      <input
                        ref={passwordInputRef}
                        type={passwordVisible ? "text" : "password"}
                        name="password"
                        placeholder="Password"
                        value={formLoginData?.password}
                        onKeyDown={(e) =>
                          e.code === "Space" && e.preventDefault()
                        }
                        onChange={handleInputChange}
                        required
                      />
                      <span
                        style={passwordIconStyle}
                        className="password-toggle-icon"
                        onClick={togglePasswordVisibility}
                      >
                        {passwordVisible ? <FaEye /> : <FaEyeSlash />}
                      </span>
                    </div>

                    {errorLoginMessage && (
                      <div className="error ErrorBlink">
                        {errorLoginMessage}
                      </div>
                    )}
                    {isChangePasswordSucced && (
                      <div className="success SuccessBlink">
                        Password successfully changed
                      </div>
                    )}
                    <button className="BtnFormLogin" id="BtnPopup_Login">
                      Login Now
                    </button>
                  </form>
                  <div className="RowFooterLogin">
                    <p>
                      <Link
                        href="#"
                        className="LinkPopup"
                        onClick={Click_ResetPassword}
                      >
                        Forgot Password?
                      </Link>
                    </p>
                  </div>
                </div>
              )}
              {/* <!-- LOGIN BOX --> */}

              {/* <!-- SIGNUP BOX --> */}
              {activeTab === "signup" && (
                <div id="RegisterBox" className="ContPopupForms">
                  <form
                    className="LoginForm"
                    autoComplete="off"
                    onSubmit={BtnSignup}
                  >
                    <div className="RowColForm">
                      <div className="ColForm">
                        <input
                          type="text"
                          name="firstName"
                          placeholder="First name:"
                          autoComplete="off"
                          required
                          value={formSignupData?.firstName}
                          onChange={handleInputSignupChange}
                        />
                      </div>
                      <div className="ColForm">
                        <input
                          type="text"
                          name="lastName"
                          placeholder="Last name:"
                          autoComplete="off"
                          required
                          value={formSignupData?.lastName}
                          onChange={handleInputSignupChange}
                        />
                      </div>
                    </div>
                    <div className="RowColForm">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email:"
                        maxLength={40}
                        autoComplete="off"
                        required
                        pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
                        value={formSignupData?.email}
                        onChange={handleInputSignupChange}
                      />
                    </div>
                    <div className="RowColForm">
                      <input
                        type="password"
                        name="password"
                        minLength={6}
                        maxLength={16}
                        placeholder="Password:"
                        autoComplete="new-password"
                        value={formSignupData?.password}
                        onKeyDown={(e) =>
                          e.code === "Space" && e.preventDefault()
                        }
                        onChange={handleInputSignupChange}
                        required
                      />
                    </div>
                    <div className="RowColForm">
                      <input
                        type="text"
                        name="phoneNumber"
                        maxLength={40}
                        placeholder="Telephone:"
                        required
                        value={formSignupData?.phoneNumber}
                        onChange={handleInputSignupChange}
                        inputMode="numeric"
                      />
                    </div>
                    <div className="RowColForm">
                      <input
                        type="text"
                        name="address"
                        maxLength={40}
                        placeholder="Address:"
                        required
                        value={formSignupData?.address}
                        onChange={handleInputSignupChange}
                      />
                    </div>
                    <div className="RowColForm">
                      <input
                        type="text"
                        name="zipCode"
                        maxLength={20}
                        placeholder="ZIP Code:"
                        required
                        value={formSignupData?.zipCode}
                        onChange={handleInputSignupChange}
                      />
                    </div>

                    <div className="RowColForm">
                      <div className="ColForm">
                        <CountryID
                          countryId={countryId}
                          handleChangeCountryId={handleChangeCountryId}
                        />
                      </div>
                      <div className="ColForm TeBoxSelectst">
                        <select
                          value={selectedGender}
                          onChange={handleGenderChange}
                          required
                        >
                          <option value="">Gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </select>
                      </div>
                    </div>
                    {countries.find((value) => value?.countryId === countryId)
                      ?.states?.length > 0 && (
                      <div className="RowColForm">
                        <div
                          className="TeBoxSelectst"
                          style={{ width: "100%" }}
                        >
                          <select
                            value={state}
                            id="Se_States"
                            required
                            className="NoSelect"
                            onChange={(event) => setState(event.target.value)}
                          >
                            <option value="">Select state</option>
                            {countries
                              .find((value) => value?.countryId === countryId)
                              ?.states?.map((value, index) => (
                                <option key={index} value={value.state}>
                                  {value.description}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    )}

                    <div className="RowForm ColLabelDate">Birthdate:</div>
                    <div className="RowForm InputDate">
                      {/* NEW DATE 3 FIELDS */}
                      <DatePickerDropdown onChange={handleDateChange} />
                      {/* NEW DATE 3 FIELDS */}
                    </div>

                    {errorRegisterMessage && (
                      <div className="error" style={{ marginTop: 10 }}>
                        {errorRegisterMessage}
                      </div>
                    )}

                    <button className="BtnFormLogin" id="BtnSignup">
                      Sign up
                    </button>
                  </form>

                  <div className="RowFooterLogin">
                    <p className="TermsText">
                      By clicking the Sign Up button, you confirm that you
                      accept our{" "}
                      <Link href="/terms" className="LinkPopup">
                        Terms of use
                      </Link>{" "}
                      and{" "}
                      <Link href="/policy" className="LinkPopup">
                        Privacy Policy.
                      </Link>{" "}
                    </p>
                  </div>
                </div>
              )}
              {/* <!-- SIGNUP BOX --> */}

              {/* <!-- RESET PASSWORD --> */}
              {activeTab === "reset-password" && (
                <div id="LoginBox" className="ContPopupForms">
                  <form className="LoginForm" onSubmit={BtnResetPassword}>
                    <input
                      type="text"
                      name="userName"
                      minLength={6}
                      maxLength={32}
                      placeholder="Email"
                      value={formResetData?.userName}
                      onChange={handleInputChangeUserName}
                      autoComplete="off"
                      required
                    />
                    {isRessetSucced && (
                      <>
                        <div
                          className="passwordContainerReset"
                          style={passwordContainer}
                        >
                          <input
                            type={passwordVisible ? "text" : "password"}
                            name="newPassword"
                            minLength={6}
                            maxLength={16}
                            placeholder="New Password:"
                            autoComplete="new-password"
                            value={formResetData?.newPassword}
                            onChange={handleInputChangeUserName}
                            required
                          />
                          <span
                            style={passwordToggleIconStyleReset}
                            className="password-toggle-icon"
                            onClick={togglePasswordVisibility}
                          >
                            {passwordVisible ? <FaEye /> : <FaEyeSlash />}
                          </span>
                        </div>
                        <input
                          type="text"
                          name="token"
                          placeholder="Token"
                          value={formResetData?.token}
                          onChange={handleInputChangeUserName}
                          autoComplete="off"
                          required
                        />
                        <span>
                          A security token has been sent to your email.
                        </span>
                      </>
                    )}
                    {errorResetMessage && (
                      <div
                        style={{ marginTop: 10 }}
                        className="error ErrorBlink"
                      >
                        {errorResetMessage}
                      </div>
                    )}
                    <button className="BtnFormLogin" id="BtnResetPassword">
                      Reset Password
                    </button>
                  </form>
                </div>
              )}
              {/* <!-- RESET PASSWORD BOX --> */}
            </>
          )}
          {/* --------------------------------------[HIDE IF USER IS LOGGED]┘ */}

          {/* USER DETAILS */}
          {user && (
            <div id="ContUserDetails">
              <div className="RowUserName">{user?.username} </div>
              <table className="UserDetTable">
                <tbody>
                  <tr>
                    <td className="TLeft">
                      <h2>Real Balance:</h2>
                    </td>
                    <td className="TLeft">
                      <strong className="Color_Yellow">
                        {user?.balance} {user?.currencyId}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td className="TLeft">
                      <h2>Bonus Balance:</h2>
                    </td>
                    <td className="TLeft">
                      <strong className="Color_Yellow">
                        {user?.bonusBalance} {user?.currencyId}
                      </strong>
                    </td>
                  </tr>

                  <tr>
                    <td className="TLeft">
                      <h2>Comp Points: </h2>
                    </td>
                    <td className="TLeft">
                      <strong className="Color_Yellow">
                        {user?.compPoints}{" "}
                      </strong>
                    </td>
                  </tr>

                  <tr>
                    <td className="TLeft">
                      <h2>Withdrawable: </h2>
                    </td>
                    <td className="TLeft">
                      <strong className="Color_Yellow">
                        {user?.withdrawableBalance} {user?.currencyId}
                      </strong>
                    </td>
                  </tr>

                  <tr>
                    <td className="TLeft">
                      <h2>Playthrough: </h2>
                    </td>
                    <td className="TLeft">
                      <strong className="Color_Yellow">
                        {user?.playThroughBalance} {user?.currencyId}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="RowUserDet">
                <div className="RowDesktop">
                  <button
                    className="UserBtns Cyan"
                    onClick={() => openCashier()}
                  >
                    Cashier
                  </button>
                  <button className="UserBtns GreyBlue" onClick={BtnLogout}>
                    Logout
                  </button>
                </div>

                {/* {isUserDetailsVisible && (
                  <button className="UserBtns Cyan" onClick={toggleUserDetails}>
                    Coupons
                  </button>
                )}
                {!isUserDetailsVisible && (
                  <button className="UserBtns Cyan" onClick={toggleUserDetails}>
                    User Details
                  </button>
                )} */}
              </div>

              <div className="RowMobile">
                <div className="RowUserDet">
                  <button
                    className="UserBtns Cyan"
                    onClick={() => openCashier("1")}
                  >
                    Deposit
                  </button>
                  <button
                    className="UserBtns Cyan"
                    onClick={() => openCashier("2")}
                  >
                    Coupons
                  </button>
                  <button
                    className="UserBtns Cyan"
                    onClick={() => openCashier("3")}
                  >
                    Withdraw
                  </button>
                </div>
              </div>

              <div className="RowMobile">
                <div className="RowUserDet">
                  {/* <div className="BtnLogout GreyBlue" onClick={BtnLogout}>
                    Logout
                  </div> */}
                  <div
                    className="BtnLogout GreyBlue"
                    onClick={() => {
                      console.log("Username from button: " + user?.username);
                      BtnLogout(user?.username);
                    }}
                  >
                    Logout
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* USER DETAILS */}
        </div>
      </div>
      {/* -----------------------------------------[MAIN LOGIN FORM]┘ */}
    </div>
      )}
      <EmailVerificationBanner />
    </>
  );
}
